/**
 * speechGate — "всё внимание на спикера" (2026-06-12, big-call feedback).
 *
 * While anyone on the live call is actively talking, presence/messaging
 * UI sounds (join/leave knocks, message pings) must NOT play: in a
 * 27-person call with connection churn they fire constantly and walk all
 * over the speaker. LiveKit maintains `room.activeSpeakers` from audio
 * levels with a hangover, so natural inter-word pauses don't flicker the
 * gate open.
 *
 * Deliberately NOT gated: ringtones (an incoming call must ring),
 * self join/leave cues (private feedback to the local user about their
 * own transition), screen-share start/stop, soundboard (deliberate acts).
 */
import { type Room } from 'livekit-client'
import { useLivekitStore } from '../stores/livekitStore'
import { useDmCallStore } from '@os/messenger/web/stores/dmCallStore'

function roomHasActiveSpeech(room: Room | null | undefined): boolean {
  if (!room) return false
  try {
    return Array.isArray(room.activeSpeakers) && room.activeSpeakers.length > 0
  } catch {
    // Partial mocks / rooms mid-teardown — treat as silent.
    return false
  }
}

export function isAnyoneSpeakingInCall(): boolean {
  try { if (roomHasActiveSpeech(useLivekitStore.getState().room)) return true } catch { /* store not ready */ }
  try { if (roomHasActiveSpeech(useDmCallStore.getState().room)) return true } catch { /* store not ready */ }
  return false
}
